<app-input-label *ngIf="!noLabel" [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<div class="password-container">
  <input
    [id]="id"
    [name]="name"
    class="password"
    [class.invalid]="isInvalid"
    [type]="passwordType"
    [placeholder]="placeholder || ''"
    [maxlength]="maxLength"
    [disabled]="isDisabled"
    [mask]="inputMask || ''"
    [autofocus]="inputAutofocus"
    inputmode="numeric"
    [pattern]="pattern"
    [decimal]="allowDecimals"
    [decimalSeparator]="decimalSeparator"
    digitOnly
    [appAutofocus]="autofocus"
    [(ngModel)]="value"
    (blur)="onTouched($event)"
    (input)="handleInput()"

  >
  <div class="password-icon"
    (click)="onIconClick()">
    <app-lucide-icon [iconName]="iconName" [size]="57"></app-lucide-icon>
  </div>
</div>
